import { Stack } from '@mui/material';
import { FlowDurationUnits } from 'flow-schema';

import { Text } from 'common';

import { PATIENT_REPLY_TIMEOUT_HELPER_TEXT, TIMEOUT_HELPER_TEXT } from './documentation';
import { BlockValueTemplateField } from '../../ConfigFields/CodeMirror/FlowTemplate';
import { BlockDurationField } from '../../ConfigFields/Duration';

const TIMEOUT_LABEL = 'Timeout';
const PATIENT_REPLY_TIMEOUT_LABEL = 'Patient Reply Timeout';

export function ReopenModeFormFields() {
  return (
    <Stack gap={2}>
      <BlockValueTemplateField
        fieldName="config.existingConversationId"
        label="Existing Conversation ID"
        helperText="Provide the existing conversation ID to reopen"
        required
      />
      <BlockValueTemplateField
        fieldName="config.firstMessage"
        label="Message"
        helperText="The message to send to the patient when reopening the conversation"
        required
      />
      <Text variant="subtitle2" bold>
        ⚠️ HIPAA Security Notice
      </Text>
      <Text variant="subtitle2">
        SMS communications are not encrypted or secure. DO NOT configure workflows that request,
        collect, or transmit PHI via SMS. <br></br> PHI includes: patient names, medical conditions,
        symptoms, medications, appointment details with providers, or any health-related
        information.
      </Text>
      <BlockDurationField
        variant="BlockValueTemplate"
        fieldName="config.timeout"
        unitFieldNameSuffix="units"
        required={true}
        allowedUnits={[FlowDurationUnits.Minutes, FlowDurationUnits.Hours, FlowDurationUnits.Days]}
        toggleLabel={TIMEOUT_LABEL}
        valueLabel={TIMEOUT_LABEL}
        valueHelperText={TIMEOUT_HELPER_TEXT}
      />
      <BlockDurationField
        variant="BlockValueTemplate"
        fieldName="config.noPatientResponseTimeout"
        unitFieldNameSuffix="units"
        required={false}
        allowedUnits={[FlowDurationUnits.Minutes, FlowDurationUnits.Hours, FlowDurationUnits.Days]}
        toggleLabel={PATIENT_REPLY_TIMEOUT_LABEL}
        valueLabel={PATIENT_REPLY_TIMEOUT_LABEL}
        valueHelperText={PATIENT_REPLY_TIMEOUT_HELPER_TEXT}
      />
    </Stack>
  );
}
